var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},[_c('BannerTop'),_c('BannerTopProfitReport'),(_vm.isLoadingData)?_c('SkeletonTopCards'):_c('TopCards'),(_vm.isLoadingData)?_c('SkeletonHotelSaldos'):_c('HotelSaldos'),(_vm.isLoadingData)?_c('SkeletonHotelsRsv'):_c('CardBookings')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }